// src/components/pages/Homepage/Homepage.js
import HeroSection from './seccions/HeroSection';
import SolutionsSection from './seccions/SolutionsSection';
import DiscoverySection from './seccions/DiscoverySection';
import QuoteSection from './seccions/QuoteSection';
import MissionVisionValuesSection from './seccions/MissionVisionValuesSection';
import AboutUsSection from './seccions/AboutUsSection';
import AlliancesSection from './seccions/AlliancesSection';
import SEO from '../../common/SEO';

const Homepage = ({
  homepageData,
  heroData,
  solutionsData,
  aboutData,
  partnersData,
  valuesData,
}) => {

  const { discovery_service_section, quote } = homepageData || {};

  console.log(homepageData)

  return (
  <div className='homepage'>
    <SEO 
      title="E2E Travel Solutions | Tecnología end-to-end para empresas de turismo"
      description="Soluciones B2B para vender y operar viajes: motor de aéreos, hoteles, asistencias, trenes, circuitos y discovery tecnológico. Optimiza procesos, conversiones y experiencia de usuario."
    />
    <HeroSection data={heroData} />
    <SolutionsSection  data={solutionsData} />
    <DiscoverySection  data={discovery_service_section} />
    <AlliancesSection  data={partnersData} />
    <AboutUsSection  data={aboutData} />
    <MissionVisionValuesSection  data={valuesData} />
    <QuoteSection data={quote} />
  </div>
)
}
export default Homepage;



